import React from 'react';

import { css, cx } from '@emotion/css';
import { SketchPicker } from 'react-color';

import { Icons } from '@/assets/icons.ts';
import { useStyles } from '@/hooks/useStyles.ts';
import { Theme } from '@/theme/CreateTheme.ts';
import { ToggleButton } from '@/uiKit/atoms/ToggleButton.tsx';
import { MenuTooltip } from '@/uiKit/atoms/floating/MenuTooltip.tsx';
import { AtomProps } from '@/uiKit/atoms/utils/AtomTypes.ts';
import { toggleButtonStyles } from '@/uiKit/molecules/RichText/inputs/RichTextInputTypes.ts';

export type BaseTextColorPickerButtonProps = {
  color: string;
  onSelectColor: (color: string) => void;
};

export type TextColorPickerButtonProps =
  AtomProps<BaseTextColorPickerButtonProps>;

export const TextColorPickerButton: React.FC<TextColorPickerButtonProps> = ({
  color,
  onSelectColor,
  className,
  ...props
}) => {
  const styles = useStyles(makeStyles, color);

  return (
    <MenuTooltip
      className={cx(styles.container, className)}
      placement="right-end"
      wrapperClassName={styles.container}
      animation={{
        duration: 0,
      }}
      content={
        <SketchPicker
          color={color ?? '#FFF'}
          onChangeComplete={color => onSelectColor(color.hex)}
        />
      }
      closeOnInteract={false}
      click={{ enabled: true }}
      openOnHover={false}
    >
      <ToggleButton
        value="text-color"
        aria-label="color"
        toggled={false}
        onToggle={() => {}}
        {...props}
      >
        <Icons.colorSelect
          className={cx(toggleButtonStyles.icon, styles.selectedColor)}
        />
      </ToggleButton>
    </MenuTooltip>
  );
};

const makeStyles = (_: Theme, color: string) => ({
  container: css({
    display: 'flex',
  }),
  selectedColor: css({
    '> .selected-color': {
      fill: color,
    },
  }),
});
